
;(function seibertronWorkGloveClipsQuantityOriginal20260715() {
  if (window.location.pathname.indexOf('/products/seibertron-patented-work-glove-clips') === -1) return;
  if (window.__seibertronWorkClipColorGalleryV4) return;
  window.__seibertronWorkClipColorGalleryV4 = true;
  var handle = "seibertron-patented-work-glove-clips";
  var exactEntries = [{"value":"Yellow 4 Pieces","variantId":"41897968304318","color":"Yellow","quantity":4,"id":"33449970139326","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-yellow-4-20260715.jpg?v=1784090508","alt":"Yellow 4 Pieces","available":true},{"value":"Red 4 Pieces","variantId":"41897968271550","color":"Red","quantity":4,"id":"33449970073790","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-red-4-20260715.jpg?v=1784090508","alt":"Red 4 Pieces","available":true},{"value":"Black 4 Pieces","variantId":"41897968238782","color":"Black","quantity":4,"id":"33449970106558","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-black-4-20260715.jpg?v=1784090508","alt":"Black 4 Pieces","available":true},{"value":"Fluorescent Yellow 4 Pieces","variantId":"41897968337086","color":"Fluorescent Yellow","quantity":4,"id":"33449970041022","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-fluorescent-yellow-4-20260715.jpg?v=1784090508","alt":"Fluorescent Yellow 4 Pieces","available":true},{"value":"Black 2 Pieces","variantId":"41897968107710","color":"Black","quantity":2,"id":"33449969844414","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-black-2-20260715.jpg?v=1784090509","alt":"Black 2 Pieces","available":true},{"value":"Red 2 Pieces","variantId":"41897968140478","color":"Red","quantity":2,"id":"33449969942718","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-red-2-20260715.jpg?v=1784090509","alt":"Red 2 Pieces","available":true},{"value":"Yellow 2 Pieces","variantId":"41897968173246","color":"Yellow","quantity":2,"id":"33449969909950","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-yellow-2-20260715.jpg?v=1784090508","alt":"Yellow 2 Pieces","available":true},{"value":"Fluorescent Yellow 2 Pieces","variantId":"41897968206014","color":"Fluorescent Yellow","quantity":2,"id":"33449969778878","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-fluorescent-yellow-2-20260715.jpg?v=1784090508","alt":"Fluorescent Yellow 2 Pieces","available":true},{"value":"Black 3 Pieces","variantId":"45575607222462","color":"Black","quantity":3,"id":"33449969811646","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-black-3-20260715.jpg?v=1784090508","alt":"Black 3 Pieces","available":true},{"value":"Yellow 3 Pieces","variantId":"45575607255230","color":"Yellow","quantity":3,"id":"33449969975486","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-yellow-3-20260715.jpg?v=1784090509","alt":"Yellow 3 Pieces","available":true},{"value":"Fluorescent Yellow 3 Pieces","variantId":"45575607287998","color":"Fluorescent Yellow","quantity":3,"id":"33449970008254","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-fluorescent-yellow-3-20260715.jpg?v=1784090508","alt":"Fluorescent Yellow 3 Pieces","available":true},{"value":"Red 3 Pieces","variantId":"45575607320766","color":"Red","quantity":3,"id":"33449969877182","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-red-3-20260715.jpg?v=1784090509","alt":"Red 3 Pieces","available":true}];
  var groups = {"Black":[{"value":"Black 2 Pieces","variantId":"41897968107710","color":"Black","quantity":2,"id":"33449969844414","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-black-2-20260715.jpg?v=1784090509","alt":"Black 2 Pieces","available":true},{"value":"Black 3 Pieces","variantId":"45575607222462","color":"Black","quantity":3,"id":"33449969811646","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-black-3-20260715.jpg?v=1784090508","alt":"Black 3 Pieces","available":true},{"value":"Black 4 Pieces","variantId":"41897968238782","color":"Black","quantity":4,"id":"33449970106558","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-black-4-20260715.jpg?v=1784090508","alt":"Black 4 Pieces","available":true},{"value":"Black same-color gallery","color":"Black","quantity":null,"id":"33375559876798","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/work-glove-clips-gallery-05.jpg?v=1783408402","alt":"style:Black 2 Pieces | style:Black 3 Pieces | color:Black | Seibertron Work Glove Clips black original white background image"},{"value":"Black same-color gallery","color":"Black","quantity":null,"id":"33375559909566","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/work-glove-clips-gallery-06.jpg?v=1783408402","alt":"style:Black 4 Pieces | color:Black | Seibertron Work Glove Clips black original white background image"}],"Red":[{"value":"Red 2 Pieces","variantId":"41897968140478","color":"Red","quantity":2,"id":"33449969942718","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-red-2-20260715.jpg?v=1784090509","alt":"Red 2 Pieces","available":true},{"value":"Red 3 Pieces","variantId":"45575607320766","color":"Red","quantity":3,"id":"33449969877182","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-red-3-20260715.jpg?v=1784090509","alt":"Red 3 Pieces","available":true},{"value":"Red 4 Pieces","variantId":"41897968271550","color":"Red","quantity":4,"id":"33449970073790","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-red-4-20260715.jpg?v=1784090508","alt":"Red 4 Pieces","available":true},{"value":"Red same-color gallery","color":"Red","quantity":null,"id":"33375559942334","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/work-glove-clips-gallery-07.jpg?v=1783408402","alt":"style:Red 2 Pieces | style:Red 3 Pieces | color:Red | Seibertron Work Glove Clips red original white background image"},{"value":"Red same-color gallery","color":"Red","quantity":null,"id":"33375559975102","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/work-glove-clips-gallery-08.jpg?v=1783408402","alt":"style:Red 4 Pieces | color:Red | Seibertron Work Glove Clips red original white background image"}],"Yellow":[{"value":"Yellow 2 Pieces","variantId":"41897968173246","color":"Yellow","quantity":2,"id":"33449969909950","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-yellow-2-20260715.jpg?v=1784090508","alt":"Yellow 2 Pieces","available":true},{"value":"Yellow 3 Pieces","variantId":"45575607255230","color":"Yellow","quantity":3,"id":"33449969975486","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-yellow-3-20260715.jpg?v=1784090509","alt":"Yellow 3 Pieces","available":true},{"value":"Yellow 4 Pieces","variantId":"41897968304318","color":"Yellow","quantity":4,"id":"33449970139326","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-yellow-4-20260715.jpg?v=1784090508","alt":"Yellow 4 Pieces","available":true},{"value":"Yellow same-color gallery","color":"Yellow","quantity":null,"id":"33375560007870","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/work-glove-clips-gallery-09.jpg?v=1783408402","alt":"style:Yellow 2 Pieces | style:Yellow 3 Pieces | color:Yellow | Seibertron Work Glove Clips yellow original white background image"},{"value":"Yellow same-color gallery","color":"Yellow","quantity":null,"id":"33375560040638","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/work-glove-clips-gallery-10.jpg?v=1783408402","alt":"style:Yellow 4 Pieces | color:Yellow | Seibertron Work Glove Clips yellow original white background image"}],"Fluorescent Yellow":[{"value":"Fluorescent Yellow 2 Pieces","variantId":"41897968206014","color":"Fluorescent Yellow","quantity":2,"id":"33449969778878","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-fluorescent-yellow-2-20260715.jpg?v=1784090508","alt":"Fluorescent Yellow 2 Pieces","available":true},{"value":"Fluorescent Yellow 3 Pieces","variantId":"45575607287998","color":"Fluorescent Yellow","quantity":3,"id":"33449970008254","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-fluorescent-yellow-3-20260715.jpg?v=1784090508","alt":"Fluorescent Yellow 3 Pieces","available":true},{"value":"Fluorescent Yellow 4 Pieces","variantId":"41897968337086","color":"Fluorescent Yellow","quantity":4,"id":"33449970041022","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-work-glove-clips-fluorescent-yellow-4-20260715.jpg?v=1784090508","alt":"Fluorescent Yellow 4 Pieces","available":true},{"value":"Fluorescent Yellow same-color gallery","color":"Fluorescent Yellow","quantity":null,"id":"33375560073406","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/work-glove-clips-gallery-11.jpg?v=1783408402","alt":"style:Fluorescent Yellow 2 Pieces | style:Fluorescent Yellow 3 Pieces | color:Fluorescent Yellow | Seibertron Work Glove Clips fluorescent yellow original white background image"},{"value":"Fluorescent Yellow same-color gallery","color":"Fluorescent Yellow","quantity":null,"id":"33375560106174","src":"https://cdn.shopify.com/s/files/1/0623/6153/4654/files/work-glove-clips-gallery-12.jpg?v=1783408402","alt":"style:Fluorescent Yellow 4 Pieces | color:Fluorescent Yellow | Seibertron Work Glove Clips fluorescent yellow original white background image"}]};
  var manualMediaId = '';
  var hydrating = false;
  var scheduled = false;
  var forcingChoice = false;
  function root(){return document.querySelector('.auto-product[data-product-handle="' + handle + '"]');}
  function exactEntryByValue(value){return exactEntries.find(function(entry){return entry.value === value;}) || null;}
  function absolute(url){if(!url)return ''; if(url.indexOf('//')===0)return window.location.protocol+url; if(url.charAt(0)==='/')return window.location.origin+url; return url;}
  function sized(url,width){try{var parsed=new URL(absolute(url),window.location.origin); parsed.searchParams.set('width',String(width)); return parsed.href;}catch(error){return absolute(url);}}
  function escapeHtml(value){return String(value||'').replace(/[&<>"']/g,function(ch){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch];});}
  function selectedValue(scope){var checked=scope.querySelector('input[name="options[Color]"]:checked,input[name="options[color]"]:checked,input[name="options[colour]"]:checked'); return checked ? checked.value : '';}
  function setMain(scope,entry){var main=scope.querySelector('[data-auto-main-image]'); if(!main || !entry)return; main.src=sized(entry.src,1200); main.srcset=''; main.alt=entry.alt; main.setAttribute('data-work-clip-color-media-id',entry.id);}
  function renderImageChoice(label,shell,entry){label.classList.add('auto-product__choice--visual'); shell.dataset.display=entry.value; shell.style.setProperty('padding','0','important'); shell.style.setProperty('overflow','hidden','important'); shell.style.setProperty('color','transparent','important'); shell.style.setProperty('font-size','0','important'); shell.style.setProperty('line-height','0','important'); var existing=shell.querySelector('[data-work-clip-swatch-media-id="'+entry.id+'"]'); if(existing&&shell.dataset.workClipRenderedValue===entry.value)return; shell.dataset.workClipRenderedValue=entry.value; shell.innerHTML='<span class="auto-product__swatch-image" aria-label="'+escapeHtml(entry.value)+'"><img data-work-clip-swatch-media-id="'+entry.id+'" src="'+escapeHtml(sized(entry.src,180))+'" alt="'+escapeHtml(entry.value)+'" width="72" height="72" loading="eager"></span><span class="auto-product__swatch-label">'+escapeHtml(entry.value)+'</span>';}
  function hydrateSwatches(scope){scope.querySelectorAll('[data-auto-visual-option-value]').forEach(function(label){var value=label.getAttribute('data-auto-visual-option-value')||''; var shell=label.querySelector('[data-auto-choice-label]'); var entry=exactEntryByValue(value); if(shell&&entry)renderImageChoice(label,shell,entry);});}
  function setActiveThumb(scope,id){scope.querySelectorAll('[data-auto-thumb]').forEach(function(thumb){thumb.classList.toggle('is-active',(thumb.getAttribute('data-media-id')||'')===id);});}
  function ensureThumb(scope,wrap,entry){var thumb=wrap.querySelector('[data-auto-thumb][data-media-id="'+entry.id+'"]'); if(!thumb){thumb=document.createElement('button'); thumb.type='button'; thumb.className='auto-product__thumb'; thumb.setAttribute('data-auto-thumb',''); wrap.appendChild(thumb);} thumb.setAttribute('data-media-id',entry.id); thumb.setAttribute('data-src',sized(entry.src,1200)); thumb.setAttribute('data-alt',entry.alt); thumb.setAttribute('aria-label','View '+entry.alt); thumb.setAttribute('data-work-clip-color',entry.color); if(thumb.dataset.workClipRenderedMediaId!==entry.id){thumb.dataset.workClipRenderedMediaId=entry.id; thumb.innerHTML='<img src="'+escapeHtml(sized(entry.src,160))+'" alt="'+escapeHtml(entry.alt)+'" width="76" height="76" loading="eager">';} if(!thumb.dataset.workClipColorGalleryV4Bound){thumb.dataset.workClipColorGalleryV4Bound='true'; thumb.addEventListener('click',function(){manualMediaId=entry.id; setMain(scope,entry); setActiveThumb(scope,entry.id);});} return thumb;}
  function orderedGroup(activeEntry){var group=(groups[activeEntry.color]||[]).slice(); var active=group.find(function(entry){return entry.id===activeEntry.id;})||activeEntry; return [active].concat(group.filter(function(entry){return entry.id!==active.id;}));}
  function hydrateThumbs(scope,activeEntry){var wrap=scope.querySelector('.auto-product__thumbs'); if(!wrap||!activeEntry)return; var entries=orderedGroup(activeEntry); var keepIds=entries.map(function(entry){return entry.id;}); entries.forEach(function(entry){ensureThumb(scope,wrap,entry);}); var activeId=manualMediaId&&keepIds.indexOf(manualMediaId)!==-1?manualMediaId:activeEntry.id; wrap.querySelectorAll('[data-auto-thumb]').forEach(function(thumb){var id=thumb.getAttribute('data-media-id')||''; var keep=keepIds.indexOf(id)!==-1; thumb.hidden=!keep; thumb.setAttribute('aria-hidden',keep?'false':'true'); if(keep)thumb.style.removeProperty('display'); else thumb.style.setProperty('display','none','important'); thumb.classList.toggle('is-active',keep&&id===activeId);}); var current=Array.from(wrap.querySelectorAll('[data-auto-thumb]')).filter(function(thumb){return keepIds.indexOf(thumb.getAttribute('data-media-id')||'')!==-1;}).map(function(thumb){return thumb.getAttribute('data-media-id')||'';}); if(current.join('|')!==keepIds.join('|'))entries.forEach(function(entry){var thumb=wrap.querySelector('[data-auto-thumb][data-media-id="'+entry.id+'"]'); if(thumb)wrap.appendChild(thumb);}); scope.setAttribute('data-work-clip-color-group',activeEntry.color); scope.setAttribute('data-work-clip-visible-media-ids',keepIds.join(','));}
  function activate(scope,value,resetManual){var entry=exactEntryByValue(value); if(!entry)return; if(resetManual)manualMediaId=''; hydrating=true; hydrateSwatches(scope); hydrateThumbs(scope,entry); if(!manualMediaId)setMain(scope,entry); hydrating=false;}
  function schedule(scope){if(scheduled||hydrating)return; scheduled=true; window.setTimeout(function(){scheduled=false; activate(scope,selectedValue(scope),false);},20);}
  function settleChoice(scope,value){[0,80,300,700].forEach(function(delay){window.setTimeout(function(){var current=selectedValue(scope); activate(scope,current||value,true);},delay);});}
  function run(){var scope=root(); if(!scope)return; activate(scope,selectedValue(scope),false); if(!scope.dataset.workClipColorGalleryV4Bound){scope.dataset.workClipColorGalleryV4Bound='true'; scope.addEventListener('click',function(event){if(forcingChoice)return; var label=event.target&&event.target.closest?event.target.closest('[data-auto-visual-option-value]'):null; if(!label||!scope.contains(label))return; var value=label.getAttribute('data-auto-visual-option-value')||''; if(!exactEntryByValue(value))return; manualMediaId=''; var input=label.querySelector('input[name^="options["]'); window.setTimeout(function(){if(input&&!input.checked){forcingChoice=true; input.checked=true; input.dispatchEvent(new Event('change',{bubbles:true})); forcingChoice=false;} settleChoice(scope,value);},0);},true); scope.addEventListener('change',function(event){if(event.target&&event.target.matches('input[name^="options["]')){manualMediaId=''; settleChoice(scope,event.target.value||selectedValue(scope));}}); var observer=new MutationObserver(function(){schedule(scope);}); observer.observe(scope,{childList:true,subtree:true});}}
  run();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});
  var attempts=0; var timer=window.setInterval(function(){attempts+=1; run(); if(attempts>=100)window.clearInterval(timer);},100);
})();

(function () {
  var solagVariantScriptSrc = document.currentScript && document.currentScript.src ? document.currentScript.src : '';

  function compactSolagSizeGuide(root) {
    var scope = root || document;
    var tables = scope.querySelectorAll('.solag-size-guide__table');
    if (!tables.length) return;

    if (!document.querySelector('style[data-solag-size-guide-fix]')) {
      var style = document.createElement('style');
      style.setAttribute('data-solag-size-guide-fix', 'true');
      style.textContent = [
        '.solag-size-guide__header{background:radial-gradient(circle at 20% 24%,rgba(87,99,121,.52),transparent 32%),radial-gradient(circle at 94% 94%,rgba(93,38,39,.34),transparent 38%),linear-gradient(145deg,#2b3342 0%,#232b39 44%,#171d27 74%,#111722 100%)!important}',
        '.solag-size-guide__header p{color:rgba(255,255,255,.76)!important}',
        '.solag-size-guide__header h3{font-size:clamp(17px,1.45vw,22px)!important;line-height:1.08!important}',
        '.solag-size-guide__method{border-left-color:rgba(245,158,11,.28)!important}',
        '.solag-size-guide__method strong{font-size:13px!important}',
        '.solag-size-guide__method li{color:rgba(255,255,255,.87)!important}',
        '.solag-size-guide__method li span{background:#f59e0b!important;color:#111418!important}',
        '.solag-size-guide__table{table-layout:fixed!important}',
        '.solag-size-guide__metric-col{width:15%!important}',
        '.solag-size-guide__size-col{width:12.142%!important}',
        '.solag-size-guide__brand{min-width:0!important}',
        '.solag-size-guide__measure-visual{width:min(100%,138px)!important;margin-top:10px!important;border-radius:0!important;background:transparent!important;box-shadow:none!important;overflow:visible!important}',
        '.solag-size-guide__measure-visual img{display:block!important;width:100%!important;height:auto!important;object-fit:contain!important;image-rendering:auto!important}',
        '.solag-size-guide__table tbody th{text-align:center!important;white-space:normal!important;overflow-wrap:normal!important;line-height:1.1!important;width:15%!important}',
        '.solag-size-guide__metric-name{display:block!important;margin:0!important;padding:0!important;border-radius:0!important;background:transparent!important;color:#151a20!important;font-size:10.5px!important;line-height:1.05!important;letter-spacing:0!important}',
        '.solag-size-guide__unit{display:inline-block!important;margin:3px 0 0!important;border-radius:999px!important;padding:2px 6px!important;background:#111418!important;color:#fff!important;font-size:10px!important;line-height:1!important;letter-spacing:.04em!important}',
        '@media(max-width:749px){.solag-size-guide__header{grid-template-columns:minmax(0,.74fr) minmax(0,1.26fr)!important;padding:16px!important}.solag-size-guide__measure-visual{width:min(100%,128px)!important;margin-top:10px!important}.solag-size-guide__method{border-left:1px solid rgba(245,158,11,.28)!important;border-top:0!important;padding-left:12px!important;padding-top:0!important}.solag-size-guide__table{min-width:680px!important;table-layout:fixed!important}}',
        '@media(max-width:420px){.solag-size-guide__header{grid-template-columns:1fr!important;gap:16px!important;padding:20px 16px 18px!important}.solag-size-guide__measure-visual{width:min(48vw,168px)!important;margin-top:12px!important}.solag-size-guide__method{border-left:0!important;border-top:1px solid rgba(245,158,11,.28)!important;padding-left:0!important;padding-top:12px!important}}'
      ].join('');
      document.head.appendChild(style);
    }

    function themeAssetUrl(filename) {
      var scriptSrc = solagVariantScriptSrc;
      if (!scriptSrc) {
        var scripts = Array.prototype.slice.call(document.querySelectorAll('script[src*="solag-variant-images.js"]'));
        scriptSrc = scripts.length ? scripts[scripts.length - 1].src : '';
      }
      if (scriptSrc) return scriptSrc.replace(/assets\/solag-variant-images\.js.*/, 'assets/' + filename);
      return '/cdn/shop/files/' + filename;
    }

    function measurementDiagramHtml() {
      return [
        '<div class="solag-size-guide__measure-visual" role="img" aria-label="Hand measurement diagram showing length and palm circumference">',
        '<img src="' + themeAssetUrl('solag-measurement-method-clean-2x.png') + '" alt="Hand measurement diagram showing length and palm circumference" width="586" height="594" loading="lazy">',
        '</div>'
      ].join('');
    }

    function setHeader(th, metricLabel, unit, ariaLabel) {
      th.setAttribute('aria-label', ariaLabel + ' ' + unit);
      th.innerHTML = '<span class="solag-size-guide__metric-name">Palm<br>' + metricLabel + '</span><span class="solag-size-guide__unit">' + unit + '</span>';
    }

    Array.prototype.slice.call(tables).forEach(function (table) {
      var guide = table.closest ? table.closest('.solag-size-guide') : null;
      var header = guide ? guide.querySelector('.solag-size-guide__header') : null;
      var brand = header ? header.querySelector('.solag-size-guide__brand, div:first-child') : null;
      if (brand) {
        brand.classList.add('solag-size-guide__brand');
        if (!brand.querySelector('.solag-size-guide__measure-visual')) {
          brand.insertAdjacentHTML('beforeend', measurementDiagramHtml());
        }
        var measurementImage = brand.querySelector('.solag-size-guide__measure-visual img');
        if (measurementImage && measurementImage.src.indexOf('solag-measurement-method-original.png') !== -1) {
          measurementImage.src = themeAssetUrl('solag-measurement-method-clean-2x.png');
          measurementImage.width = 586;
          measurementImage.height = 594;
        }
      }

      if (!table.querySelector('colgroup')) {
        var colgroup = document.createElement('colgroup');
        var metricCol = document.createElement('col');
        var sizeCol = document.createElement('col');
        metricCol.className = 'solag-size-guide__metric-col';
        sizeCol.className = 'solag-size-guide__size-col';
        sizeCol.setAttribute('span', '7');
        colgroup.appendChild(metricCol);
        colgroup.appendChild(sizeCol);

        var caption = table.querySelector('caption');
        if (caption && caption.parentNode === table && caption.nextSibling) {
          table.insertBefore(colgroup, caption.nextSibling);
        } else if (caption && caption.parentNode === table) {
          table.appendChild(colgroup);
        } else {
          table.insertBefore(colgroup, table.firstChild);
        }
      }

      var firstHead = table.querySelector('thead th:first-child');
      if (firstHead) {
        firstHead.setAttribute('aria-label', 'Adult Size');
        firstHead.textContent = 'Size';
      }

      Array.prototype.slice.call(table.querySelectorAll('tbody th')).forEach(function (th) {
        var text = th.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
        var unit = text.indexOf(' cm') !== -1 || /cm$/.test(text) ? 'CM' : 'IN';
        if (text.indexOf('circumference') !== -1 || text.indexOf('circ.') !== -1) {
          setHeader(th, 'Circ.', unit, 'Palm Circumference');
        } else if (text.indexOf('length') !== -1) {
          setHeader(th, 'Length', unit, 'Palm Length');
        }
      });
    });
  }

  function initSolagVariantImages() {
    var section = document.querySelector('.solag-product');
    if (!section || document.documentElement.dataset.solagVariantImages === 'ready') return;

    document.documentElement.dataset.solagVariantImages = 'ready';
    compactSolagSizeGuide(section);

    var gallery = section.querySelector('.solag-product__gallery');
    var thumbs = section.querySelector('.solag-product__thumbs');
    var main = section.querySelector('.solag-product__main-media');
    var activeColor = '';
    var rawSafeGalleryIds = String(section.dataset.safeGalleryMediaIds || '');
    var hasSafeGalleryIds = rawSafeGalleryIds.length > 0 && rawSafeGalleryIds !== '|NONE|';
    var safeGalleryIds = rawSafeGalleryIds.split('|').reduce(function (ids, value) {
      if (value) ids[value] = true;
      return ids;
    }, {});
    if (!gallery || !thumbs || !main) return;

    if (!document.querySelector('style[data-solag-variant-images]')) {
      var style = document.createElement('style');
      style.setAttribute('data-solag-variant-images', 'true');
      style.textContent = [
        '.solag-product__thumbs{display:grid!important;gap:12px!important;align-content:start!important;max-height:640px!important;overflow-y:auto!important;padding:2px 4px 2px 2px!important;scrollbar-width:thin}',
        '.solag-product__thumb{flex:0 0 auto}',
        '.solag-product__thumb.is-active{border-color:#111418!important;box-shadow:0 0 0 2px #111418!important}',
        '#shopify-pc__banner,.shopify-pc__banner__dialog,.shopify-pc__prefs__dialog{display:none!important;visibility:hidden!important;pointer-events:none!important}',
        '.solag-related-fallback{background:#fff;padding:44px 0 32px}.solag-related-fallback__inner{max-width:1200px;margin:0 auto;padding:0 20px}.solag-related-fallback h2{margin:0 0 22px;color:#111418;font-family:Inter,"Helvetica Neue",Arial,sans-serif;font-size:clamp(24px,2vw,32px);font-weight:800;letter-spacing:0}.solag-related-fallback product-recommendations{display:block}.solag-related-fallback .product-grid{margin-top:0}.solag-related-fallback__empty{color:#5a626d;font-size:14px}',
        '@media(max-width:860px){.solag-product__gallery{display:flex!important;flex-direction:column-reverse!important}.solag-product__thumbs{display:flex!important;gap:10px!important;max-height:none!important;overflow-x:auto!important;overflow-y:hidden!important;padding:2px 2px 10px!important;margin-top:12px!important;scroll-snap-type:x proximity!important;-webkit-overflow-scrolling:touch}.solag-product__thumb{flex:0 0 72px!important;width:72px!important;scroll-snap-align:start!important}}'
      ].join('');
      document.head.appendChild(style);
    }

    function sized(url, width) {
      if (!url) return '';
      try {
        var parsed = new URL(url, window.location.origin);
        parsed.searchParams.set('width', width);
        return parsed.toString();
      } catch (error) {
        return String(url);
      }
    }

    function imageKey(url) {
      if (!url) return '';
      try {
        return new URL(url, window.location.origin).pathname.split('/').pop().toLowerCase();
      } catch (error) {
        return String(url).split('?')[0].split('/').pop().toLowerCase();
      }
    }

    function normalizeMediaId(value) {
      return String(value || '').split('/').pop();
    }

    function isSafeGalleryMediaId(value) {
      if (!hasSafeGalleryIds) return true;
      return !!safeGalleryIds[normalizeMediaId(value)];
    }

    section.querySelectorAll('[data-solag-media-button]').forEach(function (button) {
      if (!isSafeGalleryMediaId(button.dataset.mediaId)) {
        button.remove();
      }
    });

    function normalizeColor(value) {
      return String(value || '').trim().toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ');
    }

    function colorFromOptionValue(value) {
      var normalized = normalizeColor(value);
      if (normalized.indexOf('sps 2') !== -1 || normalized.indexOf('sps-2') !== -1 || normalized.indexOf('sps 5') !== -1 || normalized.indexOf('sps-5') !== -1) return normalized;
      if (normalized.indexOf('fl yellow') !== -1) return 'fluorescent yellow';
      if (normalized.indexOf('fluorescent yellow') !== -1) return 'fluorescent yellow';
      if (normalized.indexOf('army green') !== -1) return 'army green';
      if (normalized.indexOf('coyote') !== -1) return 'coyote';
      if (normalized.indexOf('black') !== -1) return 'black';
      if (normalized.indexOf('white') !== -1) return 'white';
      if (normalized.indexOf('orange') !== -1) return 'orange';
      if (normalized.indexOf('pink') !== -1) return 'pink';
      if (normalized.indexOf('red') !== -1) return 'red';
      if (normalized.indexOf('blue') !== -1) return 'blue';
      if (normalized.indexOf('brown') !== -1) return 'brown';
      if (normalized.indexOf('yellow') !== -1) return 'yellow';
      if (normalized.indexOf('grey') !== -1) return 'grey';
      if (normalized.indexOf('gray') !== -1) return 'grey';
      return normalized;
    }

    function colorTagFrom(text) {
      var match = String(text || '').match(/\bcolor\s*:\s*([^,;|\n\r]+)/i);

      // Untagged media is treated as shared content until color tags are added.
      return match ? normalizeColor(match[1]) : 'all';
    }

    function parseJson(selector, fallback) {
      try {
        var node = section.querySelector(selector);
        return node ? JSON.parse(node.textContent) : fallback;
      } catch (error) {
        return fallback;
      }
    }

    function currentOptions() {
      return Array.prototype.slice.call(section.querySelectorAll('[data-solag-option-index]')).map(function (group) {
        var checked = group.querySelector('[data-solag-option]:checked');
        return checked ? checked.value : '';
      });
    }

    function currentColor() {
      var colorGroup = Array.prototype.slice.call(section.querySelectorAll('[data-solag-option-index]')).find(function (group) {
        var name = normalizeColor(group.dataset.solagOptionName);
        if (name.indexOf('style') !== -1) {
          var selected = group.querySelector('[data-solag-option]:checked');
          return !!selected;
        }
        return name === 'color' || name === 'colour' || name === '颜色';
      });
      var checked = colorGroup ? colorGroup.querySelector('[data-solag-option]:checked') : null;
      return checked ? colorFromOptionValue(checked.value) : '';
    }

    function buttonMatchesColor(button, color) {
      var normalizedColor = normalizeColor(color);
      var mediaColor = colorTagFrom(button.dataset.colorTags || button.dataset.mediaAlt || '');
      return !normalizedColor || mediaColor === 'all' || mediaColor === normalizedColor;
    }

    function setButtonVisibility(button, isVisible) {
      button.hidden = !isVisible;
      button.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    }

    function syncThumb(src) {
      var target = imageKey(src);
      var matched = false;
      section.querySelectorAll('[data-solag-media-button]').forEach(function (button) {
        var image = button.querySelector('img');
        var source = button.dataset.mediaSrc || (image ? image.src : '');
        var isMatch = target && imageKey(source) === target;
        button.classList.toggle('is-active', isMatch);
        if (isMatch) {
          matched = true;
          if (typeof button.scrollIntoView === 'function') {
            button.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        }
      });
      if (!matched) {
        section.querySelectorAll('[data-solag-media-button]').forEach(function (button) {
          button.classList.remove('is-active');
        });
      }
    }

    function setMain(src, alt) {
      if (!src) return;
      main.src = sized(src, 1200);
      main.srcset = [500, 700, 900, 1200].map(function (width) {
        return sized(src, width) + ' ' + width + 'w';
      }).join(', ');
      if (alt) main.alt = alt;
      syncThumb(src);
    }

    function filterThumbsByColor(color, preferredMedia) {
      var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-solag-media-button]'));
      if (!buttons.length) return;

      var visibleButtons = buttons.filter(function (button) {
        return buttonMatchesColor(button, color);
      });
      if (!visibleButtons.length) visibleButtons = buttons;

      buttons.forEach(function (button) {
        setButtonVisibility(button, visibleButtons.includes(button));
      });

      var preferredKey = preferredMedia && preferredMedia.src ? imageKey(preferredMedia.src) : '';
      var preferredButton = preferredKey ? visibleButtons.find(function (button) {
        return imageKey(button.dataset.mediaSrc || '') === preferredKey;
      }) : null;
      var activeButton = visibleButtons.find(function (button) {
        return button.classList.contains('is-active');
      });
      var targetButton = preferredButton || activeButton || visibleButtons[0];
      var image = targetButton ? targetButton.querySelector('img') : null;

      if (targetButton) {
        setMain(
          targetButton.dataset.mediaSrc || (image ? image.src : ''),
          targetButton.dataset.mediaAlt || (image ? image.alt : '')
        );
      }
    }

    function bindThumb(button) {
      if (button.dataset.solagBound === 'true') return;
      button.dataset.solagBound = 'true';
      button.addEventListener('click', function () {
        if (button.hidden) return;
        var image = button.querySelector('img');
        var src = button.dataset.mediaSrc || (image ? image.src : '');
        setMain(src, button.dataset.mediaAlt || (image ? image.alt : ''));
      });
    }

    function ensureThumb(src, alt, mediaId) {
      if (!src) return;
      if (!isSafeGalleryMediaId(mediaId)) return;
      var target = imageKey(src);
      var exists = false;
      section.querySelectorAll('[data-solag-media-button]').forEach(function (button) {
        var image = button.querySelector('img');
        var source = button.dataset.mediaSrc || (image ? image.src : '');
        if (imageKey(source) === target) exists = true;
      });
      if (exists) return;

      var button = document.createElement('button');
      button.className = 'solag-product__thumb';
      button.type = 'button';
      button.setAttribute('data-solag-media-button', '');
      button.dataset.mediaId = normalizeMediaId(mediaId);
      button.dataset.safeGalleryMedia = 'true';
      button.dataset.mediaSrc = sized(src, 1200);
      button.dataset.mediaAlt = alt || main.alt || 'Product image';
      button.dataset.colorTags = alt || '';
      button.setAttribute('aria-label', 'View product image');

      var img = document.createElement('img');
      img.src = sized(src, 160);
      img.alt = button.dataset.mediaAlt;
      img.loading = 'lazy';
      img.width = 160;
      img.height = 160;
      button.appendChild(img);
      thumbs.appendChild(button);
      bindThumb(button);
    }

    function findVariantMedia(selected, productData, inlineMedia) {
      var match = null;
      if (productData && Array.isArray(productData.variants)) {
        match = productData.variants.find(function (variant) {
          return Array.isArray(variant.options) && variant.options.every(function (option, index) {
            return option === selected[index];
          });
        });
        if (match && match.featured_image && match.featured_image.src) {
          return { src: match.featured_image.src, alt: match.featured_image.alt || main.alt || '' };
        }
      }

      if (Array.isArray(inlineMedia)) {
        match = inlineMedia.find(function (item) {
          return Array.isArray(item.options) && item.options.every(function (option, index) {
            return option === selected[index];
          });
        });
        if (match && match.image && match.image.src) {
          return { src: match.image.src, alt: match.image.alt || main.alt || '' };
        }
      }

      return null;
    }

    function syncProductCopy(productData) {
      if (!productData) return;

      var freshSummary = section.getAttribute('data-tactical-summary') || '';
      var title = section.getAttribute('data-tactical-title') || productData.title || 'Seibertron tactical gloves';
      var titleNode = section.querySelector('h1');
      var breadcrumbCurrent = section.querySelector('.solag-product__breadcrumb span:last-child');
      var summaryNode = section.querySelector('.solag-product__summary');
      var detailsNode = section.querySelector('.solag-product__description .rte');

      if (titleNode) titleNode.textContent = title;
      if (breadcrumbCurrent) breadcrumbCurrent.textContent = title;
      if (summaryNode && freshSummary) summaryNode.textContent = freshSummary;
      if (detailsNode && productData.description && detailsNode.dataset.tacticalStaticDescription !== 'true') detailsNode.innerHTML = productData.description;

      if (document.title) document.title = title;
    }

    function ensureRelatedProducts(productData) {
      if (!productData || !productData.id) return;
      if (document.querySelector('product-recommendations, .solag-related-fallback')) return;

      var related = document.createElement('section');
      related.className = 'solag-related-fallback';
      related.innerHTML = [
        '<div class="solag-related-fallback__inner">',
        '<h2>FREQUENTLY BOUGHT TOGETHER</h2>',
        '<product-recommendations class="product-recommendations"><p class="solag-related-fallback__empty">Loading recommendations...</p></product-recommendations>',
        '</div>'
      ].join('');

      var judgeSection = document.querySelector('[id*="judgeme"], .jdgm-widget, .shopify-app-block');
      if (judgeSection) {
        var parentSection = judgeSection.closest('.shopify-section') || judgeSection;
        parentSection.insertAdjacentElement('afterend', related);
      } else {
        section.insertAdjacentElement('afterend', related);
      }

      var target = related.querySelector('product-recommendations');
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      var url = root + 'recommendations/products?section_id=product-recommendations&product_id=' + productData.id + '&limit=4';

      fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .then(function (text) {
          var html = document.createElement('div');
          html.innerHTML = text;
          var grid = html.querySelector('ul.product-grid');
          if (grid) {
            target.innerHTML = grid.outerHTML;
            target.classList.add('product-recommendations--loaded');
          } else {
            target.innerHTML = '<p class="solag-related-fallback__empty">No related products available.</p>';
          }
        })
        .catch(function () {
          target.innerHTML = '<p class="solag-related-fallback__empty">No related products available.</p>';
        });
    }

    function apply(productData) {
      var inlineMedia = parseJson('[data-solag-variant-media]', []);

      syncProductCopy(productData);

      if (!hasSafeGalleryIds && productData && Array.isArray(productData.images)) {
        productData.images.forEach(function (src) {
          ensureThumb(src, main.alt || 'Product image');
        });
      }

      inlineMedia.forEach(function (item) {
        if (item && item.image && item.image.src) {
          ensureThumb(item.image.src, item.image.alt || main.alt || 'Product image', item.image.id);
        }
      });

      section.querySelectorAll('[data-solag-media-button]').forEach(bindThumb);

      function updateFromSelection() {
        section.querySelectorAll('[data-solag-option-index]').forEach(function (group) {
          var checked = group.querySelector('[data-solag-option]:checked');
          var selected = group.querySelector('[data-solag-selected-option]');
          if (selected && checked) selected.textContent = checked.value;
          group.querySelectorAll('.solag-product__choice').forEach(function (choice) {
            choice.classList.remove('is-selected');
          });
          if (checked) {
            var label = checked.closest('.solag-product__choice');
            if (label) label.classList.add('is-selected');
          }
        });

        var media = findVariantMedia(currentOptions(), productData, inlineMedia);
        var nextColor = normalizeColor(currentColor());
        var colorChanged = nextColor && nextColor !== activeColor;
        filterThumbsByColor(nextColor, colorChanged || !nextColor ? media : null);
        activeColor = nextColor;
      }

      section.addEventListener('change', function (event) {
        if (event.target && event.target.matches('[data-solag-option]')) {
          setTimeout(updateFromSelection, 0);
        }
      });

      if (section.dataset.solagChoiceClickBound !== 'true') {
        section.dataset.solagChoiceClickBound = 'true';
        section.addEventListener('click', function (event) {
          var label = event.target && event.target.closest ? event.target.closest('.solag-product__choice') : null;
          if (!label || !section.contains(label)) return;
          var input = label.querySelector('[data-solag-option]');
          if (!input) return;
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            setTimeout(updateFromSelection, 0);
          }
        });
      }

      updateFromSelection();

      ensureRelatedProducts(productData);
    }

    apply(null);

    fetch(window.location.pathname + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (productData) {
        if (productData) apply(productData);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSolagVariantImages);
  } else {
    initSolagVariantImages();
  }
})();

(function () {
  function returnAssetUrl(filename) {
    var scriptSrc = document.currentScript && document.currentScript.src ? document.currentScript.src : "";
    if (!scriptSrc) {
      var scripts = Array.prototype.slice.call(document.querySelectorAll('script[src*="solag-variant-images.js"]'));
      scriptSrc = scripts.length ? scripts[scripts.length - 1].src : "";
    }
    return scriptSrc ? scriptSrc.replace(/assets\/solag-variant-images\.js.*/, "assets/" + filename) : "/cdn/shop/files/" + filename;
  }

  function cleanSeibertronReturnContact() {
    if (window.location.pathname !== "/pages/return") return;

    document.querySelectorAll(".seibertron-return__contact, .seibertron-return-fallback__contact, .seibertron-return-client__contact").forEach(function (element) {
      element.remove();
    });

    document.querySelectorAll(".seibertron-return__button--primary, .seibertron-return-fallback__button--primary, .seibertron-return-client__button--primary").forEach(function (link) {
      if (/start a return/i.test(link.textContent || "")) {
        link.setAttribute("href", "/pages/contact");
      }
    });
  }

  function initSeibertronReturnClientFallback() {
    if (window.location.pathname !== "/pages/return") return;
    cleanSeibertronReturnContact();
    if (document.querySelector("[data-native-return-policy]")) return;
    var main = document.getElementById("MainContent");
    if (!main) return;

    var returnImage = returnAssetUrl("seibertron-home-banner-returns-20260630.png");
    main.innerHTML = [
      '<style data-seibertron-return-client-fallback>',
      '.seibertron-return-client{--return-ink:#101418;--return-muted:#5d6673;--return-line:#e6e8ec;--return-blue:#0f6bff;--return-yellow:#f6c800;background:#fff;color:var(--return-ink);font-family:Inter,"Helvetica Neue",Arial,sans-serif}.seibertron-return-client *{box-sizing:border-box;letter-spacing:0}.seibertron-return-client a{color:inherit;text-decoration:none}.seibertron-return-client__wrap{width:min(1240px,calc(100% - 40px));margin:0 auto}.seibertron-return-client__hero{display:grid;grid-template-columns:minmax(0,.9fr) minmax(420px,1.1fr);gap:28px;align-items:stretch;padding:46px 0 34px}.seibertron-return-client__copy{display:flex;min-height:430px;flex-direction:column;justify-content:center;border:1px solid var(--return-line);border-radius:8px;background:radial-gradient(circle at 15% 15%,rgba(246,200,0,.22),transparent 31%),linear-gradient(145deg,#fff 0%,#f7f8fb 100%);padding:clamp(30px,5vw,62px)}.seibertron-return-client__eyebrow{width:fit-content;margin:0 0 18px;border:1px solid rgba(16,20,24,.16);border-radius:999px;padding:8px 14px;color:var(--return-muted);font-size:12px;font-weight:800;text-transform:uppercase}.seibertron-return-client h1,.seibertron-return-client h2,.seibertron-return-client h3,.seibertron-return-client p{margin:0}.seibertron-return-client h1{max-width:580px;color:var(--return-ink);font-size:clamp(42px,5vw,78px);font-weight:850;line-height:.98}.seibertron-return-client__lead{max-width:610px;margin-top:22px;color:#303843;font-size:clamp(17px,1.4vw,21px);line-height:1.52}.seibertron-return-client__actions{display:flex;flex-wrap:wrap;gap:12px;margin-top:30px}.seibertron-return-client__button{display:inline-flex;min-height:48px;align-items:center;justify-content:center;border-radius:999px;padding:0 22px;font-size:15px;font-weight:850;line-height:1}.seibertron-return-client__button--primary{background:var(--return-ink);color:#fff;box-shadow:0 14px 26px rgba(16,20,24,.18)}.seibertron-return-client__button--secondary{border:1px solid rgba(16,20,24,.18);background:#fff;color:var(--return-ink)}.seibertron-return-client__media{min-height:430px;margin:0;overflow:hidden;border-radius:8px;background:#dde1e7;box-shadow:0 18px 38px rgba(16,20,24,.12)}.seibertron-return-client__media img{display:block;width:100%;height:100%;min-height:430px;object-fit:cover;object-position:70% 50%}.seibertron-return-client__cards{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:16px;padding:0 0 42px}.seibertron-return-client__card{min-height:150px;border:1px solid var(--return-line);border-radius:8px;background:#fff;padding:24px}.seibertron-return-client__card strong{display:block;color:var(--return-ink);font-size:clamp(24px,2.1vw,34px);font-weight:850;line-height:1}.seibertron-return-client__card span{display:block;margin-top:12px;color:var(--return-muted);font-size:15px;line-height:1.55}.seibertron-return-client__band{border-top:1px solid var(--return-line);border-bottom:1px solid var(--return-line);background:#f4f6f8;padding:clamp(44px,6vw,78px) 0}.seibertron-return-client__band h2,.seibertron-return-client__support h2{color:var(--return-ink);font-size:clamp(32px,4vw,56px);font-weight:850;line-height:1}.seibertron-return-client__steps,.seibertron-return-client__details{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:14px;margin-top:28px}.seibertron-return-client__step,.seibertron-return-client__detail{border:1px solid var(--return-line);border-radius:8px;background:#fff;padding:24px}.seibertron-return-client__num{display:inline-flex;width:38px;height:38px;align-items:center;justify-content:center;border-radius:50%;background:var(--return-yellow);color:var(--return-ink);font-size:15px;font-weight:900}.seibertron-return-client__step h3,.seibertron-return-client__detail h3{margin-top:18px;color:var(--return-ink);font-size:21px;font-weight:850;line-height:1.14}.seibertron-return-client__step p,.seibertron-return-client__detail p,.seibertron-return-client__support p{margin-top:12px;color:var(--return-muted);font-size:15px;line-height:1.58}.seibertron-return-client__support{padding:clamp(44px,6vw,78px) 0}.seibertron-return-client__support-box{display:grid;grid-template-columns:1fr;gap:24px;align-items:center;border:1px solid rgba(15,107,255,.16);border-radius:8px;background:linear-gradient(90deg,rgba(15,107,255,.08),rgba(246,200,0,.16)),#fff;padding:clamp(28px,4vw,44px)}@media(max-width:989px){.seibertron-return-client__hero,.seibertron-return-client__support-box{grid-template-columns:1fr}.seibertron-return-client__cards,.seibertron-return-client__steps,.seibertron-return-client__details{grid-template-columns:repeat(2,minmax(0,1fr))}}@media(max-width:640px){.seibertron-return-client__wrap{width:min(100% - 28px,1240px)}.seibertron-return-client__copy{min-height:auto;padding:28px 22px}.seibertron-return-client__media,.seibertron-return-client__media img{min-height:260px}.seibertron-return-client__cards,.seibertron-return-client__steps,.seibertron-return-client__details{grid-template-columns:1fr}.seibertron-return-client__button{width:100%}}',
      '</style>',
      '<section class="seibertron-return-client" data-native-return-policy data-seibertron-return-client-fallback>',
      '<div class="seibertron-return-client__wrap"><div class="seibertron-return-client__hero"><div class="seibertron-return-client__copy"><p class="seibertron-return-client__eyebrow">Return Policy</p><h1>Easy, hassle-free returns</h1><p class="seibertron-return-client__lead">Not completely satisfied? Contact Seibertron support first so we can confirm eligibility, the correct return address, and the fastest next step.</p><div class="seibertron-return-client__actions"><a class="seibertron-return-client__button seibertron-return-client__button--primary" href="/pages/contact">Start a return</a><a class="seibertron-return-client__button seibertron-return-client__button--secondary" href="/collections/all">Shop replacement gear</a></div></div><figure class="seibertron-return-client__media"><img src="' + returnImage + '" alt="Customer preparing a Seibertron return shipment" width="2170" height="725" loading="eager"></figure></div>',
      '<div class="seibertron-return-client__cards"><div class="seibertron-return-client__card"><strong>30 days</strong><span>Eligible items may be returned within 30 days when new, unworn, unwashed, and complete with original tags and packaging.</span></div><div class="seibertron-return-client__card"><strong>Contact first</strong><span>Please request authorization before shipping anything back. We will provide the right return address for your location.</span></div><div class="seibertron-return-client__card"><strong>1-2 days</strong><span>After inspection, approved refunds are processed to the original payment method within 1-2 business days.</span></div></div></div>',
      '<div class="seibertron-return-client__band"><div class="seibertron-return-client__wrap"><h2>How to return your order</h2><div class="seibertron-return-client__steps"><article class="seibertron-return-client__step"><span class="seibertron-return-client__num">1</span><h3>Request authorization</h3><p>Email our team with your order number, proof of purchase, photos, and reason for return.</p></article><article class="seibertron-return-client__step"><span class="seibertron-return-client__num">2</span><h3>Pack the item</h3><p>Return the product in original packaging with tags attached and proof of purchase inside.</p></article><article class="seibertron-return-client__step"><span class="seibertron-return-client__num">3</span><h3>Ship with tracking</h3><p>Use a trackable shipping method and keep your receipt until the return is resolved.</p></article><article class="seibertron-return-client__step"><span class="seibertron-return-client__num">4</span><h3>Inspection and refund</h3><p>Approved refunds are issued after inspection. For exchanges, return the item and place a new order.</p></article></div></div></div>',
      '<div class="seibertron-return-client__wrap seibertron-return-client__support"><h2>Policy details</h2><div class="seibertron-return-client__details"><article class="seibertron-return-client__detail"><h3>Return freight</h3><p>Customers are responsible for return freight unless support confirms otherwise.</p></article><article class="seibertron-return-client__detail"><h3>Refused returns</h3><p>Used, washed, damaged, missing-tag, or unsaleable items may be refused.</p></article><article class="seibertron-return-client__detail"><h3>Warranty review</h3><p>For defects, contact us with photos and proof of purchase so we can review repair or replacement options.</p></article><article class="seibertron-return-client__detail"><h3>Exclusions</h3><p>Coverage excludes non-authorized purchases, misuse, abuse, tampering, customer modification, or caustic exposure.</p></article></div></div>',
      '<div class="seibertron-return-client__wrap seibertron-return-client__support"><div class="seibertron-return-client__support-box"><div><h2>Need help with a return?</h2><p>Send your order number, proof of purchase, product photos, and a short description of the issue.</p></div></div></div>',
      '</section>'
    ].join("");
    cleanSeibertronReturnContact();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSeibertronReturnClientFallback);
  } else {
    initSeibertronReturnClientFallback();
  }
})();
;(function () {
  var mapPromise = null;

  function assetUrl(filename) {
    var scriptSrc = typeof solagVariantScriptSrc !== 'undefined' ? solagVariantScriptSrc : '';
    if (!scriptSrc) {
      var scripts = Array.prototype.slice.call(document.querySelectorAll('script[src*="solag-variant-images.js"]'));
      scriptSrc = scripts.length ? scripts[scripts.length - 1].src : '';
    }
    if (scriptSrc) {
      var safeGalleryMapVersion = '1784011513';
      var nextUrl = scriptSrc.replace(/assets\/solag-variant-images\.js.*/, 'assets/' + filename);
      if (filename === 'safe-gallery-media-map.json' && safeGalleryMapVersion) {
        nextUrl += (nextUrl.indexOf('?') === -1 ? '?' : '&') + 'v=' + safeGalleryMapVersion;
      }
      return nextUrl;
    }
    return '';
  }

  function loadMap() {
    if (mapPromise) return mapPromise;
    var url = assetUrl('safe-gallery-media-map.json');
    if (!url || !window.fetch) {
      mapPromise = Promise.resolve({});
      return mapPromise;
    }
    mapPromise = fetch(url, { cache: 'no-store' })
      .then(function (response) { return response.ok ? response.json() : {}; })
      .catch(function () { return {}; });
    return mapPromise;
  }

  function imageKey(url) {
    if (!url) return '';
    try {
      return decodeURIComponent(new URL(url, window.location.origin).pathname.split('/').pop() || '').toLowerCase();
    } catch (error) {
      return String(url).split('?')[0].split('/').pop().toLowerCase();
    }
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function sized(url, width) {
    if (!url) return '';
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return url;
    }
  }

  function aliasesFor(value) {
    var normalized = normalize(value);
    var aliases = {};
    if (normalized) aliases[normalized] = true;
    normalized.split('-').forEach(function (part) {
      if (part.length >= 3) aliases[part] = true;
    });
    if (normalized.indexOf('gray') !== -1) aliases.grey = true;
    if (normalized.indexOf('grey') !== -1) aliases.gray = true;
    if (normalized.indexOf('fluorescent') !== -1 && normalized.indexOf('yellow') !== -1) aliases['fluorescent-yellow'] = true;
    if (normalized.indexOf('army') !== -1 && normalized.indexOf('green') !== -1) aliases['army-green'] = true;
    return Object.keys(aliases);
  }

  function colorAliasesFor(value) {
    var normalized = normalize(value);
    var groups = [];
    if (normalized.indexOf('fluorescent-yellow') !== -1 || (normalized.indexOf('fluorescent') !== -1 && normalized.indexOf('yellow') !== -1)) groups.push(['fluorescent-yellow', 'fluorescent', 'yellow']);
    if (normalized.indexOf('army-green') !== -1 || (normalized.indexOf('army') !== -1 && normalized.indexOf('green') !== -1)) groups.push(['army-green', 'army', 'green']);
    if (normalized.indexOf('coyote') !== -1) groups.push(['coyote']);
    if (normalized.indexOf('grey') !== -1 || normalized.indexOf('gray') !== -1) groups.push(['grey', 'gray']);
    if (normalized.indexOf('black') !== -1) groups.push(['black']);
    if (normalized.indexOf('white') !== -1) groups.push(['white']);
    if (normalized.indexOf('red') !== -1) groups.push(['red']);
    if (normalized.indexOf('blue') !== -1) groups.push(['blue']);
    if (normalized.indexOf('orange') !== -1) groups.push(['orange']);
    if (normalized.indexOf('pink') !== -1) groups.push(['pink']);
    if (normalized.indexOf('yellow') !== -1 && !groups.some(function (group) { return group.indexOf('yellow') !== -1; })) groups.push(['yellow']);
    if (normalized.indexOf('green') !== -1 && !groups.some(function (group) { return group.indexOf('green') !== -1; })) groups.push(['green']);
    return groups;
  }

  function thumbMatchesValue(thumb, value) {
    var text = normalize((thumb.dataset.alt || '') + ' ' + imageKey(thumb.dataset.src || ''));
    var colorGroups = colorAliasesFor(value);
    if (colorGroups.length) {
      return colorGroups.some(function (group) {
        return group.some(function (alias) { return alias.length >= 3 && text.indexOf(alias) !== -1; });
      });
    }
    return aliasesFor(value).some(function (alias) {
      return alias.length >= 3 && (text.indexOf(alias) !== -1 || alias.indexOf(text) !== -1);
    });
  }

  function hydrateAutoSwatches(section, safeThumbs) {
    section.querySelectorAll('[data-auto-visual-option-value]').forEach(function (label) {
      var shell = label.querySelector('[data-auto-choice-label]');
      var value = label.dataset.autoVisualOptionValue || label.dataset.autoColorValue || '';
      if (!shell || !value) return;

      var thumb = safeThumbs.find(function (item) { return thumbMatchesValue(item, value); });
      if (!thumb && safeThumbs.length === 1) thumb = safeThumbs[0];
      if (!thumb) {
        shell.textContent = value;
        return;
      }

      var src = thumb.dataset.src || ((thumb.querySelector('img') || {}).src || '');
      var safeValue = escapeHtml(value);
      shell.dataset.display = value;
      shell.innerHTML = [
        '<span class="auto-product__swatch-image" aria-label="' + safeValue + '">',
        '<img src="' + escapeHtml(sized(src, 180)) + '" alt="' + safeValue + '" width="72" height="72" loading="lazy">',
        '</span>',
        '<span class="auto-product__swatch-label">' + safeValue + '</span>'
      ].join('');
    });
  }

  function applySafeGalleryMap(map) {
    var products = map && map.products ? map.products : {};
    document.querySelectorAll('.auto-product[data-auto-product]').forEach(function (section) {
      var handle = section.dataset.productHandle || '';
      if (handle === 'seibertron-riding-gloves-for-naked-bike-racing-tourer-superbike-supersport-sps-3-unisex' || handle === 'seibertron-patented-work-glove-clips' || handle === 'seibertron-g-a-r-g-2-0-gel-filled-patented-anti-impact-ultra-stick-football-sports-receiver-gloves-youth-and-adult' || handle === 'seibertron-pro-3-0-elite-ultra-stick-youth-football-receiver-gloves' || handle === 'seibertron-high-vis-hrig-anti-impact-work-gloves-hi-vis-oil-and-gas-water-resistant-safety-heavy-duty-utility-mechanic-rigger-glove-with-tpr-protection-yellow-red-ce-en388-4132' || handle === 'seibertron-high-vis-wpc5-anti-cut-gloves' || handle === 'seibertron-high-vis-deckhand-gloves-high-performance-protection-impact-resistant-oil-and-gas-safety-gloves' || handle === 'seibertron-high-vis-resistant-reducing-anti-impact-mechanics-heavy-duty-safety-gloves' || handle === 'seibertron-high-vis-sdxg2-dexterity-super-grip-gel-oil-gas-anti-vibration-impact-protection-safety-gloves-ce-en388-4131' || handle === 'seibertron-high-vis-dexterity-super-grip-gel-oil-gas-anti-vibration-impact-protection-safety-gloves' || handle === 'seibertron-3m-thinsulate-work-gloves') return;
      var entry = products[handle];
      var safeKeys = entry && (entry.imageKeys || entry);
      if (!Array.isArray(safeKeys) || !safeKeys.length) return;

      var keySet = safeKeys.reduce(function (set, key) {
        if (key) set[String(key).toLowerCase()] = true;
        return set;
      }, {});
      var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-auto-thumb]'));
      thumbs.forEach(function (thumb) {
        var image = thumb.querySelector('img');
        var src = thumb.dataset.src || (image ? image.src : '');
        if (!keySet[imageKey(src)]) {
          thumb.remove();
          return;
        }
        thumb.dataset.safeGalleryMedia = 'true';
      });

      var safeThumbs = Array.prototype.slice.call(section.querySelectorAll('[data-auto-thumb][data-safe-gallery-media="true"]'));
      var mainImage = section.querySelector('[data-auto-main-image]');
      if (safeThumbs.length && mainImage) {
        var active = safeThumbs.find(function (thumb) { return thumb.classList.contains('is-active'); }) || safeThumbs[0];
        safeThumbs.forEach(function (thumb) { thumb.classList.toggle('is-active', thumb === active); });
        mainImage.src = active.dataset.src || ((active.querySelector('img') || {}).src || mainImage.src);
        mainImage.srcset = '';
        mainImage.alt = active.dataset.alt || mainImage.alt;
      }
      hydrateAutoSwatches(section, safeThumbs);
    });
  }

  function run() {
    loadMap().then(applySafeGalleryMap);
  }

  run();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  }
  window.setTimeout(run, 400);
  window.setTimeout(run, 1200);
})();
;(function () {
  var styleId = 'auto-product-visual-swatch-solag-fix';

  function setImportant(node, property, value) {
    if (node) node.style.setProperty(property, value, 'important');
  }

  function installStyle() {
    if (document.getElementById(styleId)) return;
    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = '.auto-product__choice--visual>[data-auto-choice-label]{width:72px!important;min-width:72px!important;height:72px!important;min-height:72px!important;padding:0!important;overflow:hidden!important;background:#fff!important;color:transparent!important;font-size:0!important;line-height:0!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:0!important}.auto-product__choice--visual .auto-product__swatch-image{width:100%!important;min-width:0!important;height:100%!important;min-height:0!important;display:block!important;flex:0 0 100%!important;background:#fff!important}.auto-product__choice--visual .auto-product__swatch-image img{width:100%!important;height:100%!important;object-fit:contain!important;display:block!important}.auto-product__choice--visual .auto-product__swatch-label{position:absolute!important;width:1px!important;min-width:0!important;height:1px!important;min-height:0!important;margin:-1px!important;padding:0!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;clip-path:inset(50%)!important;white-space:nowrap!important;border:0!important;color:transparent!important;font-size:0!important;line-height:0!important}@media screen and (max-width:749px){.auto-product__choice--visual>[data-auto-choice-label]{width:60px!important;min-width:60px!important;height:60px!important;min-height:60px!important}}';
    (document.body || document.head || document.documentElement).appendChild(style);
  }

  function normalize() {
    if (!document.querySelector('.auto-product__choice--visual')) return;
    installStyle();
    document.querySelectorAll('.auto-product__choice--visual > [data-auto-choice-label]').forEach(function (shell) {
      setImportant(shell, 'padding', '0');
      setImportant(shell, 'overflow', 'hidden');
      setImportant(shell, 'color', 'transparent');
      setImportant(shell, 'font-size', '0');
      setImportant(shell, 'line-height', '0');
      setImportant(shell, 'gap', '0');
    });
    document.querySelectorAll('.auto-product__choice--visual .auto-product__swatch-label').forEach(function (label) {
      setImportant(label, 'position', 'absolute');
      setImportant(label, 'width', '1px');
      setImportant(label, 'min-width', '0');
      setImportant(label, 'height', '1px');
      setImportant(label, 'min-height', '0');
      setImportant(label, 'margin', '-1px');
      setImportant(label, 'padding', '0');
      setImportant(label, 'overflow', 'hidden');
      setImportant(label, 'clip', 'rect(0 0 0 0)');
      setImportant(label, 'clip-path', 'inset(50%)');
      setImportant(label, 'white-space', 'nowrap');
      setImportant(label, 'color', 'transparent');
      setImportant(label, 'font-size', '0');
      setImportant(label, 'line-height', '0');
    });
  }

  normalize();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalize, { once: true });
  }
  window.setTimeout(normalize, 250);
  window.setTimeout(normalize, 1000);
  window.setTimeout(normalize, 2500);
})();

;(function seibertronFootballWhiteGloveCacheFix20260713() {
  var handle = 'seibertron-white-football-gloves';
  var entries = [
    { value: 'Adult Yellow', id: '33403645722814', src: '//seibertron-outdoor.com/cdn/shop/files/1_378e1234-ba8e-4581-909b-f30d29cfe69d.jpg?v=1783672483', alt: 'color:Adult Yellow | Seibertron adult football receiver gloves white background main image' },
    { value: 'Adult White', id: '33430661988542', src: '//seibertron-outdoor.com/cdn/shop/files/seibertron-pro3-adult-football-gloves-white-white-bg.jpg?v=1783913273', alt: 'color:Adult White | Seibertron adult football receiver gloves white background main image' },
    { value: 'Adult Black', id: '33376784122046', src: '//seibertron-outdoor.com/cdn/shop/files/football-adult-receiver-gallery-07.jpg?v=1783413845', alt: 'color:Adult Black | Seibertron adult football receiver gloves white background main image' },
    { value: 'Adult Red', id: '33430665199806', src: '//seibertron-outdoor.com/cdn/shop/files/seibertron-pro3-adult-football-gloves-red-white-bg.jpg?v=1783913280', alt: 'color:Adult Red | Seibertron adult football receiver gloves white background main image' },
    { value: 'Adult Pink', id: '33376784449726', src: '//seibertron-outdoor.com/cdn/shop/files/football-adult-receiver-gallery-17.jpg?v=1783413845', alt: 'color:Adult Pink | Seibertron adult football receiver gloves white background main image' }
  ];

  function section() {
    return document.querySelector('.auto-product[data-product-handle="' + handle + '"]');
  }

  function scriptUrl(filename) {
    var src = '';
    if (document.currentScript && document.currentScript.src) src = document.currentScript.src;
    if (!src) {
      var scripts = Array.prototype.slice.call(document.querySelectorAll('script[src*="solag-variant-images.js"]'));
      if (scripts.length) src = scripts[scripts.length - 1].src;
    }
    return src ? src.replace(/assets\/solag-variant-images\.js.*/, 'assets/' + filename) : '';
  }

  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }

  function sized(url, width) {
    try {
      var parsed = new URL(absolute(url), window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return absolute(url);
    }
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function byValue(value) {
    return entries.find(function (entry) { return entry.value === value; });
  }

  function selectedValue(root) {
    var checked = root.querySelector('input[name="options[Color]"]:checked, input[name="options[colour]"]:checked, input[name="options[color]"]:checked');
    return checked ? checked.value : entries[0].value;
  }

  function ensureThumb(root, wrap, entry, index) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt);
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt) + '" width="76" height="76" loading="' + (index === 0 ? 'eager' : 'lazy') + '">';
    if (!thumb.dataset.footballWhiteBound) {
      thumb.dataset.footballWhiteBound = 'true';
      thumb.addEventListener('click', function () {
        setMain(root, entry);
        activateThumb(root, entry.value);
      });
    }
    return thumb;
  }

  function setMain(root, entry) {
    var main = root.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt;
  }

  function activateThumb(root, value) {
    var entry = byValue(value) || entries[0];
    entries.forEach(function (item) {
      var thumb = root.querySelector('[data-auto-thumb][data-media-id="' + item.id + '"]');
      if (!thumb) return;
      var active = item.id === entry.id;
      thumb.classList.toggle('is-active', active);
      thumb.hidden = !active;
      thumb.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    setMain(root, entry);
  }

  function hydrateSwatches(root) {
    root.querySelectorAll('[data-auto-visual-option-value]').forEach(function (label) {
      var value = label.getAttribute('data-auto-visual-option-value') || '';
      var entry = byValue(value);
      var shell = label.querySelector('[data-auto-choice-label]');
      if (!entry || !shell) return;
      shell.dataset.display = value;
      shell.innerHTML = [
        '<span class="auto-product__swatch-image" aria-label="' + escapeHtml(value) + '">',
        '<img src="' + escapeHtml(sized(entry.src, 180)) + '" alt="' + escapeHtml(value) + '" width="72" height="72" loading="lazy">',
        '</span>',
        '<span class="auto-product__swatch-label">' + escapeHtml(value) + '</span>'
      ].join('');
    });
  }

  function replaceChart(root) {
    var chartUrl = scriptUrl('football-gloves-adult-size-chart-user-vertical-20260723-v4.jpg');
    if (!chartUrl) return;
    root.querySelectorAll('img.auto-product__guide-image, img[src*="football-gloves-adult-size-chart"]').forEach(function (img) {
      img.src = chartUrl;
      img.srcset = '';
      img.width = 1122;
      img.height = 1402;
      img.alt = 'Seibertron adult football gloves size chart with hand measurement method, palm length, and palm circumference';
    });
  }

  function run() {
    var root = section();
    if (!root) return;
    replaceChart(root);
    var wrap = root.querySelector('.auto-product__thumbs');
    if (wrap) {
      entries.forEach(function (entry, index) { ensureThumb(root, wrap, entry, index); });
      root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
        var keep = entries.some(function (entry) { return thumb.getAttribute('data-media-id') === entry.id; });
        if (!keep) thumb.remove();
      });
    }
    hydrateSwatches(root);
    activateThumb(root, selectedValue(root));
    if (!root.dataset.footballWhiteFallbackBound) {
      root.dataset.footballWhiteFallbackBound = 'true';
      root.addEventListener('change', function (event) {
        if (event.target && event.target.matches('input[name^="options["]')) {
          window.setTimeout(function () { activateThumb(root, selectedValue(root)); hydrateSwatches(root); }, 0);
        }
      });
    }
  }

  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  window.setTimeout(run, 250);
  window.setTimeout(run, 1000);
  window.setTimeout(run, 2500);
})();






// BEGIN seibertronHpirgReceiverCacheFix20260714
;(function seibertronHpirgReceiverCacheFix20260714() {
  var handle = "seibertron-h-p-i-r-g-touchscreen-white-football-receiver-gloves";
  var entries = [
  {
    "id": "33443621011646",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-black-gold-palm-white-bg-20260714.jpg?v=1784017643",
    "alt": "seibertron-gallery:hpirg-black-white-bg-20260714 | product:8307911884990 | color:Black | slot:1 | Seibertron H.P.I.R.G touchscreen football receiver gloves black gold palm white background main image"
  },
  {
    "id": "33443157901502",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-black-01.jpg?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:Black | slot:2 | Seibertron H.P.I.R.G touchscreen football receiver gloves black touchscreen feature image"
  },
  {
    "id": "33443157934270",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-black-02.jpg?v=1784011502",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:Black | slot:3 | Seibertron H.P.I.R.G touchscreen football receiver gloves black field lifestyle image"
  },
  {
    "id": "33443157967038",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-black-04.jpg?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:Black | slot:4 | Seibertron H.P.I.R.G touchscreen football receiver gloves black running lifestyle image"
  },
  {
    "id": "33443157999806",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-black-05.jpg?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:Black | slot:5 | Seibertron H.P.I.R.G touchscreen football receiver gloves black catch lifestyle image"
  },
  {
    "id": "33443158032574",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-black-06.jpg?v=1784011502",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:Black | slot:6 | Seibertron H.P.I.R.G touchscreen football receiver gloves black catch lifestyle image 2"
  },
  {
    "id": "33443158065342",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-black-07.jpg?v=1784011502",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:Black | slot:7 | Seibertron H.P.I.R.G touchscreen football receiver gloves black touchdown lifestyle image"
  },
  {
    "id": "33443158098110",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-white-main.jpg?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:White | slot:8 | Seibertron H.P.I.R.G touchscreen football receiver gloves white background main image"
  },
  {
    "id": "33443158130878",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-white-01.jpg?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:White | slot:9 | Seibertron H.P.I.R.G touchscreen football receiver gloves white touchscreen feature image"
  },
  {
    "id": "33443158163646",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-white-02.jpg?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:White | slot:10 | Seibertron H.P.I.R.G touchscreen football receiver gloves white football closeup image"
  },
  {
    "id": "33443158196414",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-white-03.jpg?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:White | slot:11 | Seibertron H.P.I.R.G touchscreen football receiver gloves white palm protection image"
  },
  {
    "id": "33443158229182",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-white-04.png?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:White | slot:12 | Seibertron H.P.I.R.G touchscreen football receiver gloves white glove field image"
  },
  {
    "id": "33443158261950",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-white-05.jpg?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:White | slot:13 | Seibertron H.P.I.R.G touchscreen football receiver gloves white football closeup image 2"
  },
  {
    "id": "33443158294718",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-aplus-01.png?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:all | slot:14 | Seibertron H.P.I.R.G touchscreen football receiver gloves A plus touchscreen feature banner"
  },
  {
    "id": "33443158327486",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-aplus-02.png?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:all | slot:15 | Seibertron H.P.I.R.G touchscreen football receiver gloves A plus fit feature banner"
  },
  {
    "id": "33443158360254",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-aplus-03.png?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:all | slot:16 | Seibertron H.P.I.R.G touchscreen football receiver gloves A plus breathable feature banner"
  },
  {
    "id": "33443158393022",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-aplus-04.png?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:all | slot:17 | Seibertron H.P.I.R.G touchscreen football receiver gloves A plus protection feature banner"
  },
  {
    "id": "33443158425790",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-aplus-05.png?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:all | slot:18 | Seibertron H.P.I.R.G touchscreen football receiver gloves A plus sticky palm feature banner"
  },
  {
    "id": "33443158458558",
    "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-aplus-06.png?v=1784011501",
    "alt": "seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:all | slot:19 | Seibertron H.P.I.R.G touchscreen football receiver gloves A plus easy on feature banner"
  }
];
  var groups = {
  "Black": [
    "33443621011646",
    "33443157901502",
    "33443157934270",
    "33443157967038",
    "33443157999806",
    "33443158032574",
    "33443158065342",
    "33443158294718",
    "33443158327486",
    "33443158360254",
    "33443158393022",
    "33443158425790",
    "33443158458558"
  ],
  "White": [
    "33443158098110",
    "33443158130878",
    "33443158163646",
    "33443158196414",
    "33443158229182",
    "33443158261950",
    "33443158294718",
    "33443158327486",
    "33443158360254",
    "33443158393022",
    "33443158425790",
    "33443158458558"
  ]
};

  function currentColor(root) {
    var checked = root.querySelector('input[name="options[Color]"]:checked, input[name="options[color]"]:checked');
    return checked ? checked.value : '';
  }

  function isTargetRoot(root) {
    if (!root) return false;
    if (String(root.getAttribute('data-product-handle') || '') !== handle) return false;
    return String(window.location.pathname || '').indexOf(handle) !== -1;
  }

  function entryById(id) {
    id = String(id || '');
    for (var i = 0; i < entries.length; i += 1) {
      if (String(entries[i].id) === id) return entries[i];
    }
    return null;
  }

  function applyMain(root, entry) {
    if (!entry) return;
    var main = root.querySelector('[data-auto-main-image]');
    if (main && entry.src) {
      main.src = entry.src;
      main.srcset = '';
      main.alt = entry.alt || '';
      main.setAttribute('data-media-id', entry.id);
    }
    var activeThumb = root.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      thumb.classList.toggle('is-active', thumb === activeThumb);
      thumb.setAttribute('aria-current', thumb === activeThumb ? 'true' : 'false');
    });
  }

  function trimUnavailableColors(root) {
    root.querySelectorAll('input[name="options[Color]"], input[name="options[color]"]').forEach(function (input) {
      var keep = !!groups[input.value];
      var label = input.closest ? input.closest('label') : root.querySelector('label[for="' + input.id + '"]');
      input.disabled = !keep;
      if (label) {
        label.hidden = !keep;
        label.style.display = keep ? '' : 'none';
      }
    });
    if (!groups[currentColor(root)]) {
      var firstColor = Object.keys(groups)[0];
      var firstInput = root.querySelector('input[name="options[Color]"][value="' + firstColor + '"], input[name="options[color]"][value="' + firstColor + '"]');
      if (firstInput) {
        firstInput.checked = true;
        firstInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function showGroup(root, color) {
    var ids = groups[color] || groups[String(color || '').trim()] || groups.Black || [];
    var visible = {};
    ids.forEach(function (id) { visible[String(id)] = true; });
    var first = null;
    root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      var id = String(thumb.dataset.mediaId || thumb.getAttribute('data-media-id') || '');
      var keep = !!visible[id];
      thumb.hidden = !keep;
      thumb.style.display = keep ? '' : 'none';
      if (keep && !first) first = entryById(id) || { id: id, src: thumb.dataset.src, alt: thumb.dataset.alt };
    });
    applyMain(root, first);
  }

  function hydrateSwatches(root) {
    trimUnavailableColors(root);
    Object.keys(groups).forEach(function (color) {
      var first = entryById(groups[color][0]);
      if (!first || !first.src) return;
      root.querySelectorAll('[data-auto-visual-option-value="' + color + '"], [data-auto-color-value="' + color + '"]').forEach(function (label) {
        var shell = label.querySelector('[data-auto-choice-label]');
        if (!shell) return;
        shell.dataset.display = color;
        shell.innerHTML = '<span class="auto-product__swatch-image" aria-label="' + color + '"><img src="' + first.src + '" alt="' + color + '" width="72" height="72" loading="lazy"></span><span class="auto-product__swatch-label">' + color + '</span>';
      });
      root.querySelectorAll('input[name="options[Color]"][value="' + color + '"], input[name="options[color]"][value="' + color + '"]').forEach(function (input) {
        var label = input.closest ? input.closest('label') : root.querySelector('label[for="' + input.id + '"]');
        if (!label) return;
        label.style.backgroundImage = 'url("' + first.src + '")';
        label.style.backgroundSize = 'cover';
        label.style.backgroundPosition = 'center';
      });
    });
  }

  function run() {
    document.querySelectorAll('.auto-product[data-auto-product][data-product-handle="' + handle + '"]').forEach(function (root) {
      if (!isTargetRoot(root)) return;
      hydrateSwatches(root);
      showGroup(root, currentColor(root));
      if (!root.dataset.hpirgHpSeriesBound) {
        root.dataset.hpirgHpSeriesBound = 'true';
        root.addEventListener('change', function (event) {
          if (event.target && event.target.matches('input[name^="options["]')) {
            window.setTimeout(function () { hydrateSwatches(root); showGroup(root, currentColor(root)); }, 0);
          }
        });
        root.addEventListener('click', function (event) {
          var thumb = event.target && event.target.closest ? event.target.closest('[data-auto-thumb]') : null;
          if (!thumb || thumb.hidden || thumb.style.display === 'none') return;
          var entry = entryById(thumb.dataset.mediaId) || { id: thumb.dataset.mediaId, src: thumb.dataset.src, alt: thumb.dataset.alt };
          applyMain(root, entry);
        }, true);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
  window.setTimeout(run, 250);
  window.setTimeout(run, 1200);
  window.setTimeout(run, 3000);
})();
// END seibertronHpirgReceiverCacheFix20260714
/* hpirg-cache-refresh: 2026071424 */

// BEGIN seibertronHpirgTwoColorGalleryRuntimeFix20260714
;(function seibertronHpirgTwoColorGalleryRuntimeFix20260714() {
  var handle = 'seibertron-h-p-i-r-g-touchscreen-white-football-receiver-gloves';
  var allowedColors = { Black: true, White: true };
  var staleMediaIds = { '33443157868734': true, '33431615242430': true, '33431615635646': true };
  var groups = {
    Black: [
      { id: '33443621011646', src: 'https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-black-gold-palm-white-bg-20260714.jpg?v=1784017643', alt: 'seibertron-gallery:hpirg-black-white-bg-20260714 | product:8307911884990 | color:Black | slot:1 | Seibertron H.P.I.R.G touchscreen football receiver gloves black gold palm white background main image' },
      { id: '33443157901502', src: 'https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-black-01.jpg?v=1784011501', alt: 'seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:Black | slot:2 | Seibertron H.P.I.R.G touchscreen football receiver gloves black touchscreen feature image' },
      { id: '33443157934270', src: 'https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-black-02.jpg?v=1784011502', alt: 'seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:Black | slot:3 | Seibertron H.P.I.R.G touchscreen football receiver gloves black field lifestyle image' },
      { id: '33443157967038', src: 'https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-black-04.jpg?v=1784011501', alt: 'seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:Black | slot:4 | Seibertron H.P.I.R.G touchscreen football receiver gloves black running lifestyle image' },
      { id: '33443157999806', src: 'https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-black-05.jpg?v=1784011501', alt: 'seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:Black | slot:5 | Seibertron H.P.I.R.G touchscreen football receiver gloves black catch lifestyle image' },
      { id: '33443158032574', src: 'https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-black-06.jpg?v=1784011502', alt: 'seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:Black | slot:6 | Seibertron H.P.I.R.G touchscreen football receiver gloves black catch lifestyle image 2' },
      { id: '33443158065342', src: 'https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-black-07.jpg?v=1784011502', alt: 'seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:Black | slot:7 | Seibertron H.P.I.R.G touchscreen football receiver gloves black touchdown lifestyle image' }
    ],
    White: [
      { id: '33443158098110', src: 'https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-white-main.jpg?v=1784011501', alt: 'seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:White | slot:8 | Seibertron H.P.I.R.G touchscreen football receiver gloves white background main image' },
      { id: '33443158130878', src: 'https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-white-01.jpg?v=1784011501', alt: 'seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:White | slot:9 | Seibertron H.P.I.R.G touchscreen football receiver gloves white touchscreen feature image' },
      { id: '33443158163646', src: 'https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-white-02.jpg?v=1784011501', alt: 'seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:White | slot:10 | Seibertron H.P.I.R.G touchscreen football receiver gloves white football closeup image' },
      { id: '33443158196414', src: 'https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-white-03.jpg?v=1784011501', alt: 'seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:White | slot:11 | Seibertron H.P.I.R.G touchscreen football receiver gloves white palm protection image' },
      { id: '33443158229182', src: 'https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-white-04.png?v=1784011501', alt: 'seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:White | slot:12 | Seibertron H.P.I.R.G touchscreen football receiver gloves white glove field image' },
      { id: '33443158261950', src: 'https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-white-05.jpg?v=1784011501', alt: 'seibertron-gallery:hpirg-hp-series-20260714 | product:8307911884990 | color:White | slot:13 | Seibertron H.P.I.R.G touchscreen football receiver gloves white football closeup image 2' }
    ]
  };
  var shared = [
    { id: '33443158294718', src: 'https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-aplus-01.png?v=1784011501', alt: 'Seibertron H.P.I.R.G touchscreen football receiver gloves A plus touchscreen feature banner' },
    { id: '33443158327486', src: 'https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-aplus-02.png?v=1784011501', alt: 'Seibertron H.P.I.R.G touchscreen football receiver gloves A plus fit feature banner' },
    { id: '33443158360254', src: 'https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-aplus-03.png?v=1784011501', alt: 'Seibertron H.P.I.R.G touchscreen football receiver gloves A plus breathable feature banner' },
    { id: '33443158393022', src: 'https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-aplus-04.png?v=1784011501', alt: 'Seibertron H.P.I.R.G touchscreen football receiver gloves A plus protection feature banner' },
    { id: '33443158425790', src: 'https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-aplus-05.png?v=1784011501', alt: 'Seibertron H.P.I.R.G touchscreen football receiver gloves A plus sticky palm feature banner' },
    { id: '33443158458558', src: 'https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpirg-hp-series-aplus-06.png?v=1784011501', alt: 'Seibertron H.P.I.R.G touchscreen football receiver gloves A plus easy on feature banner' }
  ];

  function section() {
    return document.querySelector('.auto-product[data-product-handle="' + handle + '"], .auto-product[data-auto-product][data-product-handle="' + handle + '"]');
  }
  function absolute(url) { return url && url.indexOf('//') === 0 ? window.location.protocol + url : url; }
  function sized(url, width) {
    try { var parsed = new URL(absolute(url), window.location.origin); parsed.searchParams.set('width', String(width)); return parsed.href; }
    catch (error) { return absolute(url); }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; });
  }
  function currentColor(root) {
    var checked = root.querySelector('input[name="options[Color]"]:checked, input[name="options[color]"]:checked, input[name="options[colour]"]:checked');
    return checked && allowedColors[checked.value] ? checked.value : 'Black';
  }
  function setMain(root, entry) {
    var main = root.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || '';
    main.setAttribute('data-media-id', entry.id);
  }
  function buildThumb(entry, index, root) {
    var thumb = document.createElement('button');
    thumb.type = 'button';
    thumb.className = 'auto-product__thumb' + (index === 0 ? ' is-active' : '');
    thumb.setAttribute('data-auto-thumb', '');
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.setAttribute('aria-current', index === 0 ? 'true' : 'false');
    thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="' + (index === 0 ? 'eager' : 'lazy') + '">';
    thumb.addEventListener('click', function () {
      root.querySelectorAll('[data-auto-thumb]').forEach(function (item) { item.classList.remove('is-active'); item.setAttribute('aria-current', 'false'); });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-current', 'true');
      setMain(root, entry);
    });
    return thumb;
  }
  function hideRemovedColors(root) {
    root.querySelectorAll('input[name="options[Color]"], input[name="options[color]"], input[name="options[colour]"]').forEach(function (input) {
      var keep = !!allowedColors[input.value];
      var label = input.closest ? input.closest('label') : root.querySelector('label[for="' + input.id + '"]');
      if (!keep) {
        input.disabled = true;
        input.checked = false;
        input.hidden = true;
        if (label) {
          label.hidden = true;
          label.style.display = 'none';
          label.setAttribute('aria-hidden', 'true');
        }
      }
    });
  }
  function hydrateColorSwatches(root) {
    ['Black', 'White'].forEach(function (color) {
      var input = root.querySelector('input[name="options[Color]"][value="' + color + '"], input[name="options[color]"][value="' + color + '"], input[name="options[colour]"][value="' + color + '"]');
      if (!input) return;
      var label = input.closest ? input.closest('label') : root.querySelector('label[for="' + input.id + '"]');
      var shell = label && label.querySelector('[data-auto-choice-label]');
      var entry = groups[color][0];
      if (!label || !shell || !entry) return;
      label.hidden = false;
      label.style.display = '';
      shell.innerHTML = '<span class="auto-product__swatch-image" aria-label="' + color + '"><img src="' + escapeHtml(sized(entry.src, 180)) + '" alt="' + color + '" width="72" height="72" loading="lazy"></span><span class="auto-product__swatch-label">' + color + '</span>';
    });
  }
  function rebuild(root) {
    if (!root) return;
    hideRemovedColors(root);
    hydrateColorSwatches(root);
    var color = currentColor(root);
    var entries = (groups[color] || groups.Black).concat(shared);
    var wrap = root.querySelector('.auto-product__thumbs');
    if (wrap) {
      wrap.innerHTML = '';
      entries.forEach(function (entry, index) { wrap.appendChild(buildThumb(entry, index, root)); });
    } else {
      root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
        var id = thumb.getAttribute('data-media-id') || (thumb.dataset ? thumb.dataset.mediaId : '');
        var text = ((thumb.dataset && thumb.dataset.alt) || thumb.textContent || '').toLowerCase();
        if (staleMediaIds[id] || text.indexOf('color:yellow') !== -1 || text.indexOf('color:red') !== -1) thumb.remove();
      });
    }
    setMain(root, entries[0]);
  }
  function run() { rebuild(section()); }
  if (window.location.pathname.indexOf('/products/' + handle) === -1) return;
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('input[name^="options["]')) window.setTimeout(run, 0);
  });
  window.setTimeout(run, 100);
  window.setTimeout(run, 500);
  window.setTimeout(run, 1500);
  window.setTimeout(run, 3000);
  window.setTimeout(run, 6000);
})();
// END seibertronHpirgTwoColorGalleryRuntimeFix20260714

